import type { TFunction } from 'i18next';

type ApiDefinition = {
  getTitle: (t: TFunction<'ns1'>) => string;
  getDescription: (t: TFunction<'ns1'>) => string;
};

type ApiDefinitions = {
  [key: string]: ApiDefinition;
};

const apiDefinitions: ApiDefinitions = {
  newMembersBrandLoyalty: {
    getTitle: t => t('page.loyaltyPerformanceReport.newMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.newMembers.brandLoyalty.description'),
  },
  newMembersLocation: {
    getTitle: t => t('page.loyaltyPerformanceReport.newMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.newMembers.locationTabs.description'),
  },
  newMembersOffer: {
    getTitle: t => t('page.loyaltyPerformanceReport.newMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.newMembers.offerTabs.description'),
  },
  membersWhoOrdered: {
    getTitle: t => t('page.loyaltyPerformanceReport.membersWhoOrdered.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.membersWhoOrdered.description'),
  },
  totalMembersBrandLoyalty: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalMembers.description'),
  },
  deletedAccounts: {
    getTitle: t => t('page.loyaltyPerformanceReport.deletedAccounts.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.deletedAccounts.description'),
  },
  deletedAccountsBrandLoyalty: {
    getTitle: t => t('page.loyaltyPerformanceReport.deletedAccounts.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.deletedAccounts.brandLoyalty.description',
      ),
  },
  activeMembers: {
    getTitle: t => t('page.loyaltyPerformanceReport.activeMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.activeMembers.description'),
  },
  activeMembersBrandLoyalty: {
    getTitle: t => t('page.loyaltyPerformanceReport.activeMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.activeMembers.brandLoyalty.description'),
  },
  activeMemberPercent: {
    getTitle: t => t('page.loyaltyPerformanceReport.activeMemberPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.activeMemberPercent.description'),
  },
  activityRateAllMembers: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.activityRateAllMembers.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.activityRateAllMembers.description'),
  },
  systemActiveMemberPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.systemActiveMemberPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.systemActiveMemberPercent.description'),
  },
  pointsEarned: {
    getTitle: t => t('page.loyaltyPerformanceReport.pointsEarned.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.pointsEarned.description'),
  },
  pointsRedeemed: {
    getTitle: t => t('page.loyaltyPerformanceReport.pointsRedeemed.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.pointsRedeemed.description'),
  },
  pointsExpired: {
    getTitle: t => t('page.loyaltyPerformanceReport.pointsExpired.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.pointsExpired.description'),
  },
  discountAmount: {
    getTitle: t => t('page.loyaltyPerformanceReport.discountAmount.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.discountAmount.description'),
  },
  loyaltyDiscountAmount: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.loyaltyDiscountAmount.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyDiscountAmount.description'),
  },
  loyaltyContributionPercentOfSales: {
    getTitle: t =>
      t(
        'page.loyaltyPerformanceReport.loyaltyContributionPercentOfSales.label',
      ),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.loyaltyContributionPercentOfSales.description',
      ),
  },
  systemContributionRate: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.systemContributionRate.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.systemContributionRate.description'),
  },
  loyaltyAverageCheck: {
    getTitle: t => t('page.loyaltyPerformanceReport.loyaltyAverageCheck.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyAverageCheck.description'),
  },
  averageCheck: {
    getTitle: t => t('page.loyaltyPerformanceReport.averageCheck.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyAverageCheck.description'),
  },
  startingBalance: {
    getTitle: t => t('page.loyaltyPerformanceReport.startingBalance.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.startingBalance.description'),
  },
  endingBalance: {
    getTitle: t => t('page.loyaltyPerformanceReport.endingBalance.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.endingBalance.description'),
  },
  locationName: {
    getTitle: t => t('page.loyaltyPerformanceReport.locationName.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.locationName.description'),
  },
  loyaltyOfferName: {
    getTitle: t => t('page.loyaltyPerformanceReport.loyaltyOfferName.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyOfferName.description'),
  },
  currentStatus: {
    getTitle: t => t('page.loyaltyPerformanceReport.currentStatus.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.currentStatus.description'),
  },
  offerType: {
    getTitle: t => t('page.loyaltyPerformanceReport.offerType.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.offerType.description'),
  },
  distributionMethod: {
    getTitle: t => t('page.loyaltyPerformanceReport.distributionMethod.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.distributionMethod.description'),
  },
  redemptionDateRange: {
    getTitle: t => t('page.loyaltyPerformanceReport.redemptionDateRange.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.redemptionDateRange.description'),
  },
  distributionDateRange: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.distributionDateRange.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.distributionDateRange.description'),
  },
  averageDaysToRedeem: {
    getTitle: t => t('page.loyaltyPerformanceReport.averageDaysToRedeem.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.averageDaysToRedeem.description'),
  },
  redemptionsAllTimeDistributions: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.redemptionsAllTimeDistributions.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionsAllTimeDistributions.description',
      ),
  },
  redemptionsSelectedTimePeriodDistributions: {
    getTitle: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionsSelectedTimePeriodDistributions.label',
      ),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionsSelectedTimePeriodDistributions.description',
      ),
  },
  redemptionRateAllTime: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.redemptionRateAllTime.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.redemptionRateAllTime.description'),
  },
  redemptionRateDistributedAndRedeemedInPeriod: {
    getTitle: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionRateDistributedAndRedeemedInPeriod.label',
      ),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionRateDistributedAndRedeemedInPeriod.description',
      ),
  },
  redemptionRateDistributedAllTimeRedeemedInPeriod: {
    getTitle: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionRateDistributedAllTimeRedeemedInPeriod.label',
      ),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.redemptionRateDistributedAllTimeRedeemedInPeriod.description',
      ),
  },
  distributionsSelectedTimePeriod: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.distributionsSelectedTimePeriod.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.distributionsSelectedTimePeriod.description',
      ),
  },
  totalOpened: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalOpened.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalOpened.description'),
  },
  totalDeleted: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalDeleted.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalDeleted.description'),
  },
  totalSaved: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalSaved.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalSaved.description'),
  },
  averageDiscountPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.averageDiscountPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.averageDiscountPercent.description'),
  },
  totalOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalOrders.description'),
  },
  loyaltyEarnOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.loyaltyEarnOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyEarnOrders.description'),
  },
  loyaltyBurnOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.loyaltyBurnOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyBurnOrders.description'),
  },
  loyaltyNetZeroOrders: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.loyaltyNetZeroOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyNetZeroOrders.description'),
  },
  bonusEarnEvents: {
    getTitle: t => t('page.loyaltyPerformanceReport.bonusEarnEvents.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.bonusEarnEvents.description'),
  },
  totalLoyaltyOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.totalLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.totalLoyaltyOrders.description'),
  },
  allOrdersNetSales: {
    getTitle: t => t('page.loyaltyPerformanceReport.allOrdersNetSales.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.allOrdersNetSales.description'),
  },
  loyaltyOrdersNetSales: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.loyaltyOrdersNetSales.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.loyaltyOrdersNetSales.description'),
  },
  ordersNetSales: {
    getTitle: t => t('page.loyaltyPerformanceReport.ordersNetSales.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.ordersNetSales.description'),
  },
  loyaltyContributionPercentOfOrders: {
    getTitle: t =>
      t(
        'page.loyaltyPerformanceReport.loyaltyContributionPercentOfOrders.label',
      ),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.loyaltyContributionPercentOfOrders.description',
      ),
  },
  mobileLoyaltyOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.mobileLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.mobileLoyaltyOrders.description'),
  },
  mobileOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.mobileOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.mobileLoyaltyOrders.description'),
  },
  mobileLoyaltyOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.mobileLoyaltyOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.mobileLoyaltyOrdersPercent.description'),
  },
  mobileOrdersPercent: {
    getTitle: t => t('page.loyaltyPerformanceReport.mobileOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.mobileLoyaltyOrdersPercent.description'),
  },
  webLoyaltyOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.webLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.webLoyaltyOrders.description'),
  },
  webOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.webOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.webLoyaltyOrders.description'),
  },
  webLoyaltyOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.webLoyaltyOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.webLoyaltyOrdersPercent.description'),
  },
  webOrdersPercent: {
    getTitle: t => t('page.loyaltyPerformanceReport.webOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.webLoyaltyOrdersPercent.description'),
  },
  scanToPayLoyaltyOrders: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.scanToPayLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.scanToPayLoyaltyOrders.description'),
  },
  scanToPayOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.scanToPayOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.scanToPayLoyaltyOrders.description'),
  },
  scanToPayLoyaltyOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.scanToPayLoyaltyOrdersPercent.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.scanToPayLoyaltyOrdersPercent.description',
      ),
  },
  scanToPayOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.scanToPayOrdersPercent.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.scanToPayLoyaltyOrdersPercent.description',
      ),
  },
  otherLoyaltyOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.otherLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.otherLoyaltyOrders.description'),
  },
  otherOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.otherOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.otherLoyaltyOrders.description'),
  },
  otherLoyaltyOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.otherLoyaltyOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.otherLoyaltyOrdersPercent.description'),
  },
  otherOrdersPercent: {
    getTitle: t => t('page.loyaltyPerformanceReport.otherOrdersPercent.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.otherLoyaltyOrdersPercent.description'),
  },
  inStoreLoyaltyOrders: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.inStoreLoyaltyOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.inStoreLoyaltyOrders.description'),
  },
  inStoreOrders: {
    getTitle: t => t('page.loyaltyPerformanceReport.inStoreOrders.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.inStoreLoyaltyOrders.description'),
  },
  inStoreLoyaltyOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.inStoreLoyaltyOrdersPercent.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.inStoreLoyaltyOrdersPercent.description',
      ),
  },
  inStoreOrdersPercent: {
    getTitle: t =>
      t('page.loyaltyPerformanceReport.inStoreOrdersPercent.label'),
    getDescription: t =>
      t(
        'page.loyaltyPerformanceReport.inStoreLoyaltyOrdersPercent.description',
      ),
  },
  uniqueUserScanToPay: {
    getTitle: t => t('page.loyaltyPerformanceReport.uniqueUserScanToPay.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.uniqueUserScanToPay.description'),
  },
  uniqueUserWeb: {
    getTitle: t => t('page.loyaltyPerformanceReport.uniqueUserWeb.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.uniqueUserWeb.description'),
  },
  uniqueUserApp: {
    getTitle: t => t('page.loyaltyPerformanceReport.uniqueUserApp.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.uniqueUserApp.description'),
  },
  uniqueUserInStore: {
    getTitle: t => t('page.loyaltyPerformanceReport.uniqueUserInStore.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.uniqueUserInStore.description'),
  },
  uniqueUserOther: {
    getTitle: t => t('page.loyaltyPerformanceReport.uniqueUserOther.label'),
    getDescription: t =>
      t('page.loyaltyPerformanceReport.uniqueUserOther.description'),
  },
};

export default apiDefinitions;
